import { axiosInstance, requestConfig } from 'network/apis';

import { URL_BILLING } from 'utils/constants';

export const callInventory = async () => {
    return await axiosInstance(requestConfig('get', URL_BILLING, '/v2/item/getshopgtitems'));
};
